import React, { FunctionComponent } from 'react'
import { Dimensions, FlatList, View, ViewStyle } from 'react-native'

import styled from 'styled-components/native'

export interface CarouselEdgeSliderProps {
  items: any[]
  renderItemCallback: ({ item, index }: { item: any; index: number }) => React.JSX.Element
  showEdge?: boolean
  scale?: number
  contentContainerStyle?: ViewStyle
  paddingRight?: number
}

const DEFAULT_SLIDER_SCALE = 0.75
const DEFAULT_PADDING_SIZE = 8

const FlatListContainer = styled(View)<{ rightPadding: number }>(({ rightPadding }) => ({
  marginLeft: `-${DEFAULT_PADDING_SIZE}px`,
  marginRight: `-${rightPadding}px`,
}))

const ItemContainer = styled(View)<{ width: number | undefined }>(({ width }) => ({
  width: width ? `${width}px` : 'auto',
}))

export const CarouselEdgeSlider: FunctionComponent<CarouselEdgeSliderProps> = ({
  items,
  renderItemCallback,
  showEdge,
  scale = DEFAULT_SLIDER_SCALE,
  contentContainerStyle,
  paddingRight = DEFAULT_PADDING_SIZE,
}) => {
  const { width } = Dimensions.get('window')
  const itemCardWidth = showEdge && scale ? width * scale : undefined

  const renderItem = ({ item, index }: { item: any; index: number }) => {
    return (
      <ItemContainer key={index} testID={'CarouselEdgeSliderItemContainer-' + index} width={itemCardWidth}>
        {renderItemCallback({ item, index })}
      </ItemContainer>
    )
  }

  return (
    <FlatListContainer testID={'CarouselEdgeSlider'} rightPadding={paddingRight}>
      <FlatList
        data={items}
        renderItem={renderItem}
        horizontal
        initialScrollIndex={0}
        contentContainerStyle={{ padding: DEFAULT_PADDING_SIZE, ...contentContainerStyle }}
        showsHorizontalScrollIndicator={false}
      />
    </FlatListContainer>
  )
}
